import React__default from 'react';
import { CheckboxCore } from '../shared/components/Checkbox.mjs';
import styled from '../../../../../node_modules/@mui/material/styles/styled.mjs';
import checkboxClasses from '../../../../../node_modules/@mui/material/Checkbox/checkboxClasses.mjs';

const checkboxSx = {
    [`&, &.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
        color: (theme)=>theme.styleConfig.colors.primary
    },
    [`&.${checkboxClasses.disabled}`]: {
        color: (theme)=>theme.styleConfig.colors.secondary
    }
};
const StyledCheckbox = styled(CheckboxCore)(({ theme })=>({
        color: theme.styleConfig.colors.primary
    }));
const Checkbox = (props)=>{
    return /*#__PURE__*/ React__default.createElement(StyledCheckbox, {
        ...props,
        checkboxSx: checkboxSx
    });
};

export { Checkbox };
//# sourceMappingURL=Checkbox.mjs.map
